import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography, useTheme } from "@material-ui/core"
import React, { useRef, useState } from 'react'
import { formatDateTime } from "../../../../utils/Validators"
import { CriarIntegracaoEagle } from "./CriarIntegracaoEagle"


function resultadoAnalise(value) {
  if (value === 'APPROVED') return 'Aprovado'
  if (value === "REJECTED") return 'Recusado'
  return 'Outro'
}

function ItemInfo({ label, value }) {
  return (
    <Grid xs={6}>
      <Typography variant="caption">{label}:</Typography>
      <Typography><b>{value}</b></Typography>
    </Grid>
  )
}

function DetailDialog({
  open = false,
  handleClose,
  eagle
}) {
  const resultadoAnaliseValue = resultadoAnalise(eagle?.analiseResultado)
  const consultInDb = eagle?.fromDb === true ? "Sim" : "Não"
  const dataInicio =  formatDateTime(eagle?.createdAt)
  const dataUpdate = formatDateTime(eagle?.updatedAt)

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Detalhes da Consulta Eagle</DialogTitle>
      <DialogContent>
        <Grid container>
          <ItemInfo 
            label="Resultado"
            value={resultadoAnaliseValue}
          />
           <ItemInfo 
            label="Consulta do banco da Eagle"
            value={consultInDb}
          />
          <ItemInfo 
            label="Data Início"
            value={dataInicio}
          />
          <ItemInfo 
            label="Data Atualização"
            value={dataUpdate}
          />
          {eagle.analiseInfo && 
            <Grid xs={12}>
              <Typography variant="caption">Resumo:</Typography>
              <div dangerouslySetInnerHTML={{__html: eagle.analiseInfo}} ></div>
            </Grid>
          }
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export const EagleFinished = ({ 
  eagle, 
  creating, 
  handleRecreateNewQuery, 
  initialLoading 
}) => {
  const theme = useTheme()
  const [open, setOpen] = useState(false)
  const hiddenCreateNew = useRef(!eagle?.fromDb)

  return (
    <Grid container spacing={1} alignItems="center">
      {!initialLoading && 
        <Grid item>
          <Chip
            label="Concluído - Clique aqui para ver as informações"
            style={{
              backgroundColor: theme.palette.success.main,
              color: '#fff'
            }}
            onClick={() => setOpen(true)}
          />
        </Grid>
      }
      <Grid item>
        <CriarIntegracaoEagle 
          creating={creating}
          handleCreate={handleRecreateNewQuery}
          initialLoading={initialLoading}
          hidden={hiddenCreateNew.current}
          tooltipText="Iniciar nova integração com a Eagle"
        />
      </Grid>
      <DetailDialog 
        eagle={eagle}
        open={open}
        handleClose={() => setOpen(false)}
      />
    </Grid>
  )
}
